/**
 * 2019-04-11
 * handan
 * 页面导航
 */

import React, { Component } from 'react'
import { connect } from "react-redux";
import "./style.scss";

import { userInfo } from "../../models";
import { 
  NavLink
} from "react-router-dom";

class Nav extends Component{
  state = {
    imgurl: "",
    username: '',
  }
  render (){
    const { batchId=false } = this.props;
    const { imgurl="",username="未知昵称" } = this.state;
    return (
      <div className="Nav-wrap">
        <div className="container">
          <h1 className="logo"></h1>
          <ul>
            <li>
              {
                // batchId ? 
                // <NavLink to={`/verifyResult/${batchId}`}>发起背调</NavLink>
                // :
                // <NavLink to="/home">发起背调</NavLink>
              }
              {/* <NavLink to="/start">发起背调</NavLink> */}
              <NavLink to="/home">发起背调</NavLink>
            </li>
            <li>
              <NavLink to="/resultHistory">背调进度</NavLink>
            </li>
            <li>
              <NavLink to="/fillingMoney">充值背调点数</NavLink>
            </li>
          </ul>
          <div className="right">
            <div className="headPhoto">
              <img src={imgurl} alt=""/>
              <span>{username}</span>
            </div>
            <div className="sign"><a target="_self" href="//passport.58.com/58/logout?source=check&path=http://check.58.com/uncheck/index/index_pc/">退出</a></div>
          </div>
        </div>
      </div>
    )
  }
  componentDidMount(){
    userInfo().then((res)=>{
      this.setState({
        imgurl: res.usephoto,
        username: res.userealname
      })
    }).catch((err)=>{
    })
  }
}

const mapState = (store)=>{
  return {
    batchId: store.home.batchId,
  }
}
const mapDispatch = (dispatch)=>{
  return {

  }
}
export default connect(mapState,mapDispatch)(Nav);